__turbopack_context__.v({
  "cta": "_11AlRa_cta",
  "root": "_11AlRa_root",
});
